export default __webpack_public_path__ + "locales/si/ChangeUserTypeDialog.json?hash=449328fce6b8c158ff6bf40f708a2f9b";